import React from "react";
import axios from "axios";
import { LayoutMain } from "@unisearch/theme/layout";
import SectionTitle from "@modules/study/common/section_title";

const Discussions = () => {
  return (
    <LayoutMain
      title="Discussions"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/discussions`}
    >
      <div className="container" style={{ minHeight: "100vh" }}>
        <div style={{ marginTop: 60 }}>
          <SectionTitle
            shadow_text="Discussions"
            title="Discussion"
          ></SectionTitle>
        </div>
      </div>
    </LayoutMain>
  );
};

export default Discussions;
